module.exports = __webpack_public_path__ + "img/img_04.d3b77ec3.jpg";